// extracted by mini-css-extract-plugin
module.exports = {"childrenPagesList":"ChildrenPagesList_childrenPagesList__G-qK1"};